/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDeleteFoldersModel,
  IDeleteFoldersRequest,
  IMappers,
  IDeleteFoldersResponse,
  IDeleteFoldersResponseError,
  TDeleteFoldersResponse,
} from './types';

const defaultConfig: TDeleteFoldersModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/delete-folders/',
  hostType: 'api',
} as TDeleteFoldersModel;

function createDeleteFoldersModel(parameters: IDeleteFoldersRequest): TDeleteFoldersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDeleteFoldersOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IDeleteFoldersRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchDeleteFolders<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDeleteFoldersOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TDeleteFoldersResponse
> {
  const { response, statusCode } = await httpApi.fetch(createDeleteFoldersModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IDeleteFoldersResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IDeleteFoldersResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TDeleteFoldersResponse;
}

export { defaultConfig, createDeleteFoldersModel, fetchDeleteFolders };
